<template>
  <div :class="b()">
    <el-checkbox v-model="isMain">Главный атрибут</el-checkbox>
    <el-input v-model="name"></el-input>
    <div :class="b('possible-values')">
      <div v-for="(value, idx) in possibleValues">
        <div :class="b('possible-value')">{{ value.value }}
          <el-button @click="removeValue(idx)" icon="el-icon-delete" circle></el-button>
        </div>
      </div>
      <el-input placeholder="Добавьте значение атрибута" v-model="newValue"
                @keyup.enter.native="addNewValue"></el-input>
    </div>
    <div :class="b('btns')">
      <el-button @keyup.enter="actionApply" @click="actionApply">Принять</el-button>
      <el-button @click="actionCancel">Отменить</el-button>
    </div>
  </div>

</template>

<script>
    import CatalogService from "../services/CatalogService";
    import {EventBus} from "../event-bus";

    const COMPONENT_NAME = "attribute-form";
    const MODE_EDIT = 2;

    export default {
        name: COMPONENT_NAME,
        props: ['attribute', 'category', 'context'],
        data() {
            return {
                name: '',
                isMain: true,
                possibleValues: [],
                newValue: null
            }
        },
        created() {
            if (this.attribute) {
                this.name = this.attribute.name;
                this.isMain = _.isBoolean(this.attribute.is_main) ? this.attribute.is_main : this.attribute.is_main === 1;
            }
        },
        mounted() {
            this.getPossibleValues();
        },
        methods: {
            addNewValue() {
                if (this.newValue.length === 0) {
                    return;
                }

                this.possibleValues.push({value: this.newValue});
                this.newValue = null;
            },
            async getPossibleValues() {
                if (this.attribute) {
                    let response = await CatalogService.getPossibleValues(this.attribute.id, this.category.id);
                    if (response.success) {
                        this.possibleValues = response.possibleValues;
                    }
                }
            },
            async saveAttributeProperties() {
                let response = await CatalogService.saveAttributeProperties(
                    this.category.id, !_.isNull(this.attribute) ? this.attribute.id : null, this.name, this.possibleValues, this.isMain
                );
                if (response.success) {
                    let mode = Number.parseInt(this.context.mode);
                    EventBus.$emit(mode === MODE_EDIT ? 'update-attribute' : 'new-attribute', {
                        parentId: this.category.guid,
                        attribute: response.attribute
                    });
                }
            },
            actionApply() {
                this.saveAttributeProperties();
                this.$vuedals.close();
            },
            actionCancel() {
                this.$vuedals.close();
            },
            removeValue(idx) {
                this.possibleValues.splice(idx, 1);
            }
        }
    }
</script>

<style lang="scss" scoped>
  .attribute-form {
    display: flex;
    flex-direction: column;

    &__possible-values {
      padding: 10px 0;
    }

    &__possible-value {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px;
    }

    &__btns {
      display: flex;
      justify-content: flex-end;
    }
  }
</style>